/**
 * App specific api
 */


import { UserStatsResponse } from "./types/accounts";

import { createApi, FetchArgs } from '@reduxjs/toolkit/query/react'
import { baseQuery } from "./default";

// Define a service using a base URL and expected endpoints
export const AccountAPI = createApi({
  reducerPath:'apiAccounts',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getStats: builder.query<UserStatsResponse, void>({
      query: () => `api/accounts/stats`,
    }),
 }),
});


// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetStatsQuery } = AccountAPI;
